import { Box, CircularProgress } from "@mui/material";

export const AppWaiting = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        display: "flex",
      }}
      zIndex={99999}
    >
      <CircularProgress />
    </Box>
  );
};
